import moment from "moment";
import _ from "lodash";

export const formatDate = (dateInput) => {
    let mmDate =  moment(dateInput);
    const formattedDateString = mmDate.format('YYYY-MM-DD');
    return formattedDateString
}

export const addOneYear = (dateString) => {
    return moment(dateString, "YYYY-MM-DD").add(1, "year").format("YYYY-MM-DD");
}

export const stringToDateBeginningOfDay = (dateString) => {
    // Split the input string into its components (year, month, day)
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a new Date object with the components
    const date = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript

    // Set the time to the beginning of the day (00:00:00)
    date.setHours(0, 0, 0, 0);

    return date;
}

export const stringToDateEndOfDay = (dateString) => {
    // Split the input string into its components (year, month, day)
    const [year, month, day] = dateString.split('-').map(Number);

    // Create a new Date object with the components
    const date = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript

    // Set the time to the end of the day (23:59:59.999)
    date.setHours(23, 59, 59, 999);

    return date;
}

export const stringUTCToLocal = (utcDateString) =>{
    if (_.isEmpty(utcDateString)){
        return "";
    }
    const utcDate = moment(utcDateString).utc();

    const localDate = utcDate.local().toDate();
    return localDate;

}

export const stringUTCToLocalString = (utcDateString) =>{
    if (_.isEmpty(utcDateString)){
        return "";
    }
    const utcDate = moment(utcDateString).utc();

    const localDate = utcDate.local().format('YYYY-MM-DD'); // Adjust the format as needed
    return localDate;

}

export const stringDateToUTC = (dateString) => {
    if (_.isEmpty(dateString)){
        return "";
    }
    // Split the input string into its components (year, month, day)
    const [year, month, day] = dateString.split('-').map(Number);

    const currentDate = new Date();

    // Create a new Date object with the components
    const date = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript

    // Set the time to the beginning of the day (00:00:00)
    date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds());

    return moment.utc(date).format();
}

export const stringToDateBeginningOfDayUTC = (dateString) => {
    // Split the input string into its components (year, month, day)
    const [year, month, day] = dateString.split('-').map(Number);

    const currentDate = new Date();

    // Create a new Date object with the components
    const date = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript

    // Set the time to the beginning of the day (00:00:00)
    date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds());

    return moment.utc(date).startOf('day').format();
}

export const stringToDateEndOfDayUTC = (dateString) => {
    // Split the input string into its components (year, month, day)
    const [year, month, day] = dateString.split('-').map(Number);

    const currentDate = new Date();

    // Create a new Date object with the components
    const date = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript

    // Set the time to the beginning of the day (00:00:00)
    date.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds(), currentDate.getMilliseconds());

    return moment.utc(date).endOf('day').format();
}

export const convertToUTCString = (date) => {
    return date.toUTCString();
}

export const  convertToISOString = (date) => {
    return date.toISOString();
}

export const formatDateToYYYYMMDD = (date) => {
    if (!date){
        return ""
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
}

export const formatDateToYYYYMMDDWithSlash = (date) => {
    if (!date){
        return ""
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}/${month}/${day}`;
}

export const getThreeLetterMonthsWithYear = (months) => {
    if (!months) {
        months = 12;
    }
    const monthsWithYear = [];
    const date = new Date();
    for (let i = 0; i < months; i++) {
      date.setMonth(date.getMonth() - 1);
      const monthName = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      monthsWithYear.push(`${monthName}-${year}`);
    }
    return monthsWithYear.reverse();
  };

export const getMonthsInCurrentYear = () => {
    const currentYear = new Date().getFullYear();
    const months = [];
    for (let month = 0; month < 12; month++) {
        const monthName = new Date(currentYear, month).toLocaleString('default', { month: 'short' });
        months.push(`${monthName}-${currentYear}`);
    }
    return months;
}
  
  
  